import * as React from 'react';
import {
  ClockArrowUpIcon,
  ClockArrowDownIcon,
  PackageCheckIcon,
  TruckIcon,
} from 'lucide-react';
import type { IndicatorStatusCode } from 'contracts/tracking-v2/invoice-indicators';
import { STATUS_DESCRIPTION_MAP } from 'constants/tracking-v2/invoice-indicators';
import { getMajorStatusCode } from 'pages/tracking-v2/utils/invoice-status-code-utils';
import { cn } from 'lib/utils';

type Props = React.ComponentProps<'div'> & {
  status: IndicatorStatusCode
}

export const IndicatorStatusIcon = ({ status }: Props) => {
  const title = STATUS_DESCRIPTION_MAP[status];
  const majorStatusCode = getMajorStatusCode(status);

  const Icon = React.useMemo(() => {
    switch (majorStatusCode) {
      case 'preparingForTransit':
        return ClockArrowUpIcon;
      case 'inTransit':
        return TruckIcon;
      case 'preparingForDelivery':
        return ClockArrowDownIcon;
      case 'delivered':
        return PackageCheckIcon;
    }
  }, [majorStatusCode]);

  return (
    <div title={title} className={cn(
      'flex items-center justify-center',
      'rounded-full w-6 h-6',
      'text-slate-50',
      majorStatusCode === 'preparingForTransit' && 'bg-sky-500',
      majorStatusCode === 'inTransit' && 'bg-yellow-500',
      status === 'inTransitOverDeadline' && 'bg-orange-500',
      majorStatusCode === 'preparingForDelivery' && 'bg-indigo-500',
      majorStatusCode === 'delivered' && 'bg-green-500',
    )}>
      <Icon className={'w-4 h-4'} />
    </div>
  );
};